import React from 'react';

/**
 * Relationship Badge - Visual indicator for entity relationships
 * @param {string} label - Badge label
 * @param {number} count - Count to display
 * @param {string} icon - FA icon
 * @param {string} variant - Bootstrap variant (primary|secondary|success|info|warning|danger)
 * @param {function} onClick - Click handler
 */
const RelationshipBadge = ({ label, count, icon, variant = 'info', onClick }) => {
  const badgeClass = `badge bg-${variant} ${onClick ? 'cursor-pointer' : ''}`;

  return (
    <span className={badgeClass} onClick={onClick} role={onClick ? 'button' : undefined}>
      {icon && <i className={`fas ${icon} me-1`} />}
      {label}
      {count !== undefined && <span className="ms-1 badge bg-white text-dark">{count}</span>}
    </span>
  );
};

export default RelationshipBadge;
